import { render } from "./DDateInput.vue?vue&type=template&id=4fab87f6"
import script from "./DDateInput.vue?vue&type=script&lang=js"
export * from "./DDateInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__